module.exports = __webpack_public_path__ + "static/media/auxiliaire.22489476.jpg";